import { ValueType } from 'realgrid'

export const registFields = [
    { fieldName: 'itemCd', dataType: ValueType.TEXT },
    { fieldName: 'itemNm', dataType: ValueType.TEXT },
    { fieldName: 'nickNm', dataType: ValueType.TEXT },
    { fieldName: 'ua1', dataType: ValueType.TEXT },
    { fieldName: 'ua2', dataType: ValueType.TEXT },
    { fieldName: 'custCd',dataType: ValueType.TEXT },
    { fieldName: 'contractYn',dataType: ValueType.TEXT },
    { fieldName: 'avaQty', dataType: ValueType.NUMBER },
    { fieldName: 'avaYn', dataType: ValueType.TEXT }
  ]
  export const registColumns = [
    {
      name: 'itemCd',
      fieldName: 'itemCd',
      type: 'data',
      width: '100',
      styleName: "rg-align-center",
      header: {
        text: '제품코드',
        showTooltip: false
      },
      visible: true,
      editable: false
    },
    {
      name: 'itemNm',
      fieldName: 'itemNm',
      type: 'data',
      width: '250',
      styleName: "rg-align-center",
      header: '제품명',
      visible: true,
      editable: false
    },
    {
      name: 'avaYn',
      fieldName: 'avaYn',
      type: 'data',
      width: '80',
      styleName: "rg-align-center",
      header: '재고보유여부',
      visible: false,
      editable: false
    },
    {
      name: 'contractYn',
      fieldName: 'contractYn',
      type: 'data',
      width: '80',
      styleName: "rg-align-center",
      header: '계약여부',
      visible: false,
      editable: false
    },
    {
      name: 'nickNm',
      fieldName: 'nickNm',
      type: 'data',
      width: '200',
      styleName: "rg-align-left",
      header: '별칭',
      visible: false,
      editable: false
    },
    {
      name: 'ua1',
      fieldName: 'ua1',
      type: 'data',
      width: '100',
      styleName: "rg-align-center",
      header: '중분류',
      visible: false,
      editable: false
    },
    {
      name: 'ua2',
      fieldName: 'ua2',
      type: 'data',
      width: '100',
      styleName: "rg-align-center",
      header: '소분류',
      visible: false,
      editable: false
    },
    {
      name: 'custCd',
      fieldName: 'custCd',
      type: 'data',
      width: '200',
      styleName: "rg-align-left",
      header: '거래처코드',
      visible: false,
      editable: false
    },
    {
      name: 'avaQty',
      fieldName: 'avaQty',
      type: 'data',
      width: '50',
      numberFormat: "#,##0.#",
      styleName: "rg-align-right",
      header: {
          text: '주문가능수량',
          showTooltip: false
      },
      visible: false
  }
  ]